import * as React from "react";
import { forwardRef } from "react";
const SvgCurveRightMobile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 123, height: 71, viewBox: "0 0 123 71", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 3H70C97.6142 3 120 25.3858 120 53V68", stroke: "#EFEFEF", strokeWidth: 6, strokeLinecap: "round", strokeDasharray: "0.2 12" }));
const ForwardRef = forwardRef(SvgCurveRightMobile);
export default ForwardRef;
